console.log('Tour Gallery Block JS loaded');

addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 2,
        },
        // when window width is >= 480px
        480: {
        slidesPerView: 3,
        },
        // when window width is >= 640px
        640: {
        slidesPerView: 4,
        },
        // when window width is >= 1200px
        1200: {
        slidesPerView: 6,
        }
    }
    });
    var swiper2 = new Swiper(".mySwiper2", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      effect: "fade",
      speed: 1000,
      fadeEffect: {
            crossFade: true
        },
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      thumbs: {
        swiper: swiper,
      },
    });
});
